// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"4":"banner-lazy","40":"cookie-policy"}[chunkId] || chunkId) + ".pro.js?ver=" + {"4":"457bc469f03841de","40":"65cff3abdb14dc0f","178":"3b13e7f7d9936853","227":"d098d91cc7a7e4a0","608":"2b85377c44667b94"}[chunkId] + "";
};